import { List, Record } from "immutable";
import { IProductData } from "common/records/Product";
import { IProductOptionGroupData } from "common/records/ProductOptionGroup";
import { DateStringNumber, Nullable } from ".";
import { checkDate } from "common/helpers/Date";

export const fromJSON = (json: Partial<IPriceListData>): PriceListRecord => {
  const recordData: IPriceListRecord = { ...(json as any) };

  if (json.product_option_groups) {
    recordData.product_option_group_ids = List(json.product_option_groups.map((pog) => pog.id));
  }

  if (json.products) {
    recordData.product_ids = List(json.products.map((p) => p.id));
  }

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new PriceListRecord(recordData);
};

export interface IPriceListData {
  id: number;
  org_id: number;
  name: string;
  kind: string;
  hidden_products: boolean;
  products: IProductData[];
  product_option_groups: IProductOptionGroupData[];
  loading: boolean;
  csv_generated_on: string;
  csv_url: string;
  activated_on: string;
  activated: boolean;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IPriceListRecord {
  id: number;
  org_id: number;
  name: string;
  kind: string;
  hidden_products: boolean;
  product_ids: List<number>;
  product_option_group_ids: List<number>;
  loading: boolean;
  csv_generated_on: Nullable<string>;
  csv_url: Nullable<string>;
  activated_on: Nullable<string>;
  activated: Nullable<boolean>;

  created_at: Date;
  updated_at: Date;
}

export const defaultPriceListProps = {
  id: 0,
  org_id: 0,
  name: "",
  kind: "default",
  hidden_products: false,
  product_ids: List<number>(),
  product_option_group_ids: List<number>(),
  loading: false,
  csv_generated_on: null,
  csv_url: null,
  activated_on: null,
  activated: null,

  created_at: new Date(),
  updated_at: new Date(),
};

export class PriceListRecord extends Record<IPriceListRecord>(defaultPriceListProps) implements IPriceListRecord {}
